// useCurrencyRate.js
import { fetchCurrencyRateTable } from '@/apis/exchange';
import { useQuery } from '@tanstack/react-query';

const useCurrencyRate = () => {
  const { data, isSuccess: queryIsSuccess } = useQuery({
    queryKey: ['currencyRate'],
    queryFn: fetchCurrencyRateTable,
    enabled: true,
    initialData: {},
    // 添加缓存配置，减少不必要的请求
    staleTime: 1 * 60 * 1000, // 1分钟内数据被认为是新鲜的（汇率实时波动，缩短新鲜度时间）
    gcTime: 5 * 60 * 1000, // 5分钟垃圾回收时间，保留在内存中便于快速访问
    refetchOnWindowFocus: false, // 窗口聚焦时不重新获取
    refetchOnMount: false, // 组件挂载时不重新获取（如果有缓存）
    retry: 2, // 失败时重试2次
  });
  return { currencyRateTable: data, isSuccess: queryIsSuccess };
};

export default useCurrencyRate;
